import { useSuspenseQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { programClient } from '../client/programClient';


export const useEnrollment = (id: number | string) => {
  const { data: { data }, ...rest } = useSuspenseQuery({
    queryKey: [cacheKeys.getEnrollment, id],
    queryFn: () => programClient.getEnrollment({ id }),
    retry: false,
  });

  return {
    ...rest,
    enrollment: data,
  };
};
